import './axios'
import './sweetalert2'
import './fontawesome'
import './v-mask'
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-select'



// WEBPACK FOOTER //
// ./resources/js/plugins/index.js